import { skipToken, useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { OurUseQueryOptions } from "@nens/react-query-utils";
import { PaginatedUsageList, getHCCApi } from "@nens/threedi/openapi-client";

const getHccModelSimulationsUsagesQuery = (
  threediModelId: number | undefined
): OurUseQueryOptions<PaginatedUsageList> =>
  getRanaApiV1().getQueryOptions({
    queryKey: ["hcc-model-simulation-usages", threediModelId],
    queryFn:
      threediModelId !== undefined
        ? () => getHCCApi().usageList({ simulationThreedimodelId: threediModelId })
        : skipToken,
  });

export const useHccModelSimulationsUsagesQuery = (threediModelId: number | undefined) =>
  useQuery(getHccModelSimulationsUsagesQuery(threediModelId));
